export const chatStyles = `
html body #LeadboosterContainer {
	z-index: 99 !important;
}
html body #LeadboosterContainer.openedChat {
	height:80% !important;
	bottom: 0 !important;
	top: unset !important;
}
@media (min-width: 576px) {
	html body #LeadboosterContainer {
		bottom: 0 !important;
		right: 0 !important;
	}
}
@media (min-width: 768px) {
	html body #LeadboosterContainer {
		z-index: 999999 !important;
		bottom: 28px !important;
		right: 28px !important;
	}
}`
